import React, { useState, useEffect, useCallback } from "react";
import AdmissionInfoDialog from "../../components/AdmissionInfoDialog/AdmissionInfoDialog";
import Profile from "../Profile/Profile";
import {
  Autocomplete,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Tooltip,
  InputAdornment,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  MenuItem,
  Box,
  Button,
  IconButton,
  Alert,
  AlertTitle,
  Stack,
  Grid,
  Tabs,
  Tab,
  Divider,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import fileIcon from "../../assets/images/icons/fileicon.png";

import DescriptionIcon from "@mui/icons-material/Description"; // Import Description icon
import AddCircleIcon from "@mui/icons-material/AddCircle";
import MemberSearchDialog from "../MemberSearchDialog/MemberSearchDialog";
import FacilityService from "../../services/FacilityServices";
import AdmissionService from "../../services/AdmissionServices"; // Import AdmissionService
import HospitalService from "../../services/HospitalServices"; // Import HospitalService
import FacilityForm from "../FacilityForm/FacilityForm";
import CountryService from "../../services/CountryServices";
import { useDropzone } from "react-dropzone";
import "./ipCensusManagement.css"; // Import the CSS file
import DeleteIcon from "@mui/icons-material/Delete";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { DaysPassed } from "../../Utils/DateUtils"; // Import the DaysPassed function
import * as XLSX from "xlsx";

const columns = [
  "Hospitalization Country",
  "Hospital",
  "Member Name",
  "Country",
  "Case #",
  "Date of Service TO",
  "Date of Service From",
  "Agency",
  "DOB",
  "Diagnosis Code",
  "Action",
];

const IPCensusManagement = () => {
  const [isSearching, setIsSearching] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  //const [autoRefreshInterval, setAutoRefreshInterval] = useState(null);

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false); // Add state for edit mode
  const [currentAdmission, setCurrentAdmission] = useState(null); // Add state for current admission
  const [memberId, setMemberId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [memberSearchOpen, setMemberSearchOpen] = useState(false);
  const [facilities, setFacilities] = useState([]);
  const [dob, setDob] = useState("");
  const [authorization, setAuthorization] = useState("");
  const [diagnosisCode, setDiagnosisCode] = useState("");
  const [admissionDate, setAdmissionDate] = useState("");
  const [admissions, setAdmissions] = useState([]);
  const [dischargeDate, setDischargeDate] = useState("");
  const [country, setCountry] = useState("");
  const [agency, setAgency] = useState("");
  const [caseNumber, setCaseNumber] = useState("");
  const [notes, setNotes] = useState("");
  const [countries, setCountries] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState("");
  const [facilityDialogOpen, setFacilityDialogOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedAdmission, setSelectedAdmission] = useState(null);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [showDischarged, setShowDischarged] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [errors, setErrors] = useState({});
  const [diagnosisCodes, setDiagnosisCodes] = useState([]); // State for diagnosis codes
  const [selectedDiagnosisCode, setSelectedDiagnosisCode] = useState(null); // State for selected code
  const [estimatedAmount, setEstimatedAmount] = useState(null); // State for selected code
  const [hospitalizationCountries, setHospitalizationCountries] = useState([]);
  const [selectedHospitalizationCountry, setSelectedHospitalizationCountry] =
    useState("");
  const [admissionDateFrom, setAdmissionDateFrom] = useState("");
  const [admissionDateTo, setAdmissionDateTo] = useState("");
  const [dischargeDateFrom, setDischargeDateFrom] = useState("");
  const [dischargeDateTo, setDischargeDateTo] = useState("");
  const [dateFilterLogic, setDateFilterLogic] = useState("AND"); // "AND" or "OR"
  const [enableDischargeFilter, setEnableDischargeFilter] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [isDateFiltering, setIsDateFiltering] = useState(false);
  const [hospitalSearch, setHospitalSearch] = useState(""); // State for hospital search
  const [addressDialogOpen, setAddressDialogOpen] = useState(false);
  const [selectedHospitalAddress, setSelectedHospitalAddress] = useState(null);

  const handleAddFacility = () => {
    setFacilityDialogOpen(true);
  };

  const handleAddressDialogOpen = (hospitalData) => {
    setSelectedHospitalAddress(hospitalData);
    setAddressDialogOpen(true);
  };

  const handleAddressDialogClose = () => {
    setAddressDialogOpen(false);
    setSelectedHospitalAddress(null);
  };

  const hasAddressData = (row) => {
    return (
      (row.hospitalizationCity && row.hospitalizationCity.trim() !== "") ||
      (row.hospitalizationState && row.hospitalizationState.trim() !== "") ||
      (row.hospitalizationPostalCode &&
        row.hospitalizationPostalCode.trim() !== "")
    );
  };

  const fetchHospitalizationCountries = async () => {
    try {
      console.debug("getting hospital countries");
      const response = await AdmissionService.getHospitalizationCountries();
      console.debug("response.data.countries", response.data.countries);
      setHospitalizationCountries(response.data.countries);

      // Don't set any default selection - leave it empty
      // User must manually select a country to filter
    } catch (error) {
      console.error("Error fetching hospitalization countries:", error);
    }
  };
  useEffect(() => {
    if (hospitalizationCountries.length > 0) {
      fetchAdmissions(page, rowsPerPage);
    }
  }, [selectedHospitalizationCountry, page, rowsPerPage]);

  const handlePatientClick = (memberId) => {
    setSelectedMemberId(memberId);
    setIsProfileOpen(true);
  };

  const handleProfileClose = () => {
    setIsProfileOpen(false);
    setSelectedMemberId(null);
  };

  const handleInfoDialogOpen = async (admission) => {
    try {
      const response = await AdmissionService.getById(admission.id);
      setSelectedAdmission(response.data);
      setInfoDialogOpen(true);
    } catch (error) {
      console.error("Error fetching admission details:", error);
      alert("Error loading admission details. Please try again.");
    }
  };

  const ShowAlert = (title, message) => {
    return (
      <Stack sx={{ width: "100%" }} spacing={2}>
        <Alert severity="success">
          <AlertTitle>{title}</AlertTitle>
          {message}
        </Alert>
      </Stack>
    );
  };

  const handleFacilityDialogClose = () => {
    setFacilityDialogOpen(false);
  };

  const validateFields = () => {
    const newErrors = {};
    if (!memberId) newErrors.memberId = "Member ID is required.";
    if (!firstName) newErrors.firstName = "First Name is required.";
    if (!lastName) newErrors.lastName = "Last Name is required.";
    if (!dob) newErrors.dob = "Date of Birth is required.";
    if (!selectedFacility) newErrors.selectedFacility = "Facility is required.";

    if (!admissionDate) {
      newErrors.admissionDate = "Admit Date is required.";
    } else if (!isPastDate(admissionDate)) {
      newErrors.admissionDate = "Admit Date must be in the past.";
    }
    if (!country) newErrors.country = "Country is required.";
    if (!agency) newErrors.agency = "Agency is required.";
    if (!caseNumber) newErrors.caseNumber = "Case Number is required.";
    if (!selectedDiagnosisCode)
      newErrors.diagnosisCode = "Diagnosis Code is required."; // Updated validation

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isPastDate = (date) => {
    return new Date(date) < new Date(new Date().setHours(0, 0, 0, 0));
  };

  const handleSave = async () => {
    debugger;
    if (!validateFields()) {
      return;
    }

    const newAdmission = {
      memberId,
      firstName,
      lastName,
      dob,
      facilityId: selectedFacility,
      authorizationId: authorization,
      admissionDate,
      diagnosisCode:
        selectedDiagnosisCode.code + " - " + selectedDiagnosisCode.description,
      dischargeDate: dischargeDate === "" ? null : dischargeDate,
      countryId: country,
      agency,
      caseNumber,
      notes,
      files,
      estimatedAmount,
    };

    try {
      var createdAdmission = await AdmissionService.create(newAdmission);
      AddAttachments(createdAdmission.data.id);
      ShowAlert("Success", "Admission added successfully");
      fetchAdmissions(page, rowsPerPage); // Refresh the admissions list
      handleDialogClose(); // Close the dialog
    } catch (error) {
      console.error("Error saving admission:", error);
    }
  };

  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleDeleteFile = async (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const AddAttachments = async (admissionId, attachedFiles) => {
    const fileContents = await Promise.all(
      files.map(async (file) => {
        const base64 = await convertFileToBase64(file);
        const newadmissionatt = {
          filename: file.name,
          content: base64,
          admissionid: admissionId,
        };
        await AdmissionService.createAttachment(newadmissionatt);
      })
    );
  };

  const handleDialogOpen = () => {
    setEditMode(false);
    setCurrentAdmission(null);
    setMemberId("");
    setFirstName("");
    setLastName("");
    setDob("");
    setSelectedFacility("");
    setAuthorization("");
    setAdmissionDate("");
    setDiagnosisCode("");
    setDischargeDate("");
    setCountry("");
    setAgency("");
    setCaseNumber("");
    setNotes("");
    setFiles([]);
    setOpen(true);
  };

  const handleDialogClose = () => setOpen(false);

  const handleMemberSearchOpen = () => setMemberSearchOpen(true);
  const handleMemberSearchClose = () => setMemberSearchOpen(false);

  const fetchAll = useCallback(async (currentPage, RowsPerPage) => {
    const response = await AdmissionService.getAll(
      currentPage,
      rowsPerPage,
      showDischarged ? 1 : 0
    );
    console.log("response.data", response.data);

    setAdmissions(response.data.list);
    setTotalRows(response.data.recordCount);
  });
  const fetchAdmissions = useCallback(
    async (currentPage, rowsPerPage) => {
      try {
        console.log(
          "selectedHospitalizationCountry",
          selectedHospitalizationCountry
        );

        var response = null;
        debugger;
        if (selectedHospitalizationCountry !== "") {
          // Filter by hospitalization country
          response = await AdmissionService.filterByHospitalizationCountry(
            selectedHospitalizationCountry,
            currentPage + 1,
            rowsPerPage
          );
          console.log("response.data", response.data);

          setAdmissions(response.data.data);
          setTotalRows(response.data.count);
        } else if (isSearching && search !== "") {
          // Text search
          response = await AdmissionService.filter(
            currentPage,
            rowsPerPage,
            search
          );
          console.log("response.data", response.data);

          setAdmissions(response.data.list);
          setTotalRows(response.data.recordCount);
        } else if (isSearching && hospitalSearch !== "") {
          // Hospital search
          response = await AdmissionService.getByHospital(
            hospitalSearch,
            currentPage,
            rowsPerPage
          );
          console.log("response.data", response.data);

          setAdmissions(response.data.list);
          setTotalRows(response.data.recordCount);
        } else if (
          isDateFiltering &&
          (admissionDateFrom !== "" || admissionDateTo !== "" || 
           (enableDischargeFilter && (dischargeDateFrom !== "" || dischargeDateTo !== "")))
        ) {
          // Date filter - check if both admission and discharge dates are provided
          const hasAdmissionDates = admissionDateFrom !== "" || admissionDateTo !== "";
          const hasDischargeDates = enableDischargeFilter && (dischargeDateFrom !== "" || dischargeDateTo !== "");
          
          if (hasAdmissionDates && hasDischargeDates) {
            // Both admission and discharge dates provided - use combined filter
            response = await AdmissionService.filterByBothDates(
              admissionDateFrom,
              admissionDateTo,
              dischargeDateFrom,
              dischargeDateTo,
              dateFilterLogic,
              currentPage + 1, // API expects 1-based page numbers
              rowsPerPage
            );
            console.log("response.data", response.data);
            // Handle the new response structure
            setAdmissions(response.data.list || response.data.data || []);
            setTotalRows(response.data.recordCount || response.data.count || 0);
          } else if (hasAdmissionDates) {
            // Only admission dates provided
            response = await AdmissionService.filterByAdmissionDate(
              admissionDateFrom,
              admissionDateTo,
              currentPage,
              rowsPerPage
            );
            console.log("response.data", response.data);
            setAdmissions(response.data.list);
            setTotalRows(response.data.recordCount);
          } else if (hasDischargeDates) {
            // Only discharge dates provided
            response = await AdmissionService.filterByDischargeDate(
              dischargeDateFrom,
              dischargeDateTo,
              currentPage,
              rowsPerPage
            );
            console.log("response.data", response.data);
            setAdmissions(response.data.list);
            setTotalRows(response.data.recordCount);
          }
        } else {
          // Get all (with discharged filter)
          response = await AdmissionService.getAll(
            currentPage,
            rowsPerPage,
            showDischarged ? 1 : 0
          );
          console.log("response.data", response.data);

          setAdmissions(response.data.list);
          setTotalRows(response.data.recordCount);
        }
      } catch (error) {
        console.error("Error fetching admissions:", error);
      }
    },
    [
      showDischarged,
      selectedHospitalizationCountry,
      isSearching,
      search,
      hospitalSearch,
      isDateFiltering,
      admissionDateFrom,
      admissionDateTo,
      dischargeDateFrom,
      dischargeDateTo,
      dateFilterLogic,
      enableDischargeFilter,
    ]
  );

  /*
  const fetchFacilities = async () => {
    try {
      const response = await FacilityService.getAll();
      setFacilities(response.data);
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };
*/
  const handleMemberSelect = (member) => {
    setMemberId(member.id);
    setFirstName(member.firstName);
    setLastName(member.lastName);
    setDob(member.dob);
    setMemberSearchOpen(false);
  };
  /*
  const fetchDiagnosisCodes = async () => {
    try {
      const response = await DiagnosisCodesService.getAll();
      setDiagnosisCodes(response.data);
    } catch (error) {
      debugger;
      console.error("Error fetching diagnosis codes:", error);
    }
  };
  */
  useEffect(() => {
    fetchAdmissions(page, rowsPerPage);
    fetchCountries();
    fetchHospitalizationCountries();
  }, []);

  /*
  useEffect(() => {
    fetchAdmissions(page, rowsPerPage);

    // Set up auto-refresh interval
    const interval = setInterval(() => {
      fetchAdmissions(page, rowsPerPage);
    }, 60000); // 60000 ms = 60 seconds

    setAutoRefreshInterval(interval);

    // Clean up interval on component unmount
    return () => {
      if (autoRefreshInterval) {
        clearInterval(autoRefreshInterval);
      }
    };
  }, [fetchAdmissions, page, rowsPerPage]);
*/
  /*  
// Effect to update auto-refresh when page or rowsPerPage changes
  useEffect(() => {
    if (autoRefreshInterval) {
      clearInterval(autoRefreshInterval);
    }

    const newInterval = setInterval(() => {
      fetchAdmissions(page, rowsPerPage);
    }, 60000);

    setAutoRefreshInterval(newInterval);

    return () => {
      if (newInterval) {
        clearInterval(newInterval);
      }
    };
  }, [fetchAdmissions, page, rowsPerPage]);
*/
  useEffect(() => {
    fetchAdmissions(page, rowsPerPage);
  }, [showDischarged]);

  const fetchCountries = async () => {
    try {
      const response = await CountryService.getAll();
      setCountries(response.data);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      if (files.length + acceptedFiles.length <= 3) {
        setFiles((prevFiles) => [
          ...prevFiles,
          ...acceptedFiles.map((file) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            })
          ),
        ]);
      } else {
        alert("You can only upload up to 3 files.");
      }
    },
    maxFiles: 3,
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (search !== "") {
      handleSearch();
    } else {
      fetchAdmissions(newPage, rowsPerPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    fetchAdmissions(0, newRowsPerPage);
  };

  const fetchAndSetFacilities = async () => {
    try {
      const response = await FacilityService.getAll();
      setFacilities(response.data);
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  };

  const handleSearch = async () => {
    try {
      let response;

      if (selectedHospitalizationCountry !== "") {
        // If both filters are active, prioritize country filter for now
        // You might need a combined endpoint on the backend for this case
        response = await AdmissionService.filterByHospitalizationCountry(
          selectedHospitalizationCountry,
          page,
          rowsPerPage
        );
        setAdmissions(response.data.data);
        setTotalRows(response.data.count);
      } else if (search !== "") {
        response = await AdmissionService.filter(page, rowsPerPage, search);
        setAdmissions(response.data.list);
        setTotalRows(response.data.recordCount);
      } else if (hospitalSearch !== "") {
        response = await HospitalService.filter(
          hospitalSearch,
          page,
          rowsPerPage
        );
        setAdmissions(response.data.list);
        setTotalRows(response.data.recordCount);
      } else if (admissionDateFrom !== "" || admissionDateTo !== "" || 
                 (enableDischargeFilter && (dischargeDateFrom !== "" || dischargeDateTo !== ""))) {
        const hasAdmissionDates = admissionDateFrom !== "" || admissionDateTo !== "";
        const hasDischargeDates = enableDischargeFilter && (dischargeDateFrom !== "" || dischargeDateTo !== "");
        
        if (hasAdmissionDates && hasDischargeDates) {
          // Both admission and discharge dates provided - use combined filter
          response = await AdmissionService.filterByBothDates(
            admissionDateFrom,
            admissionDateTo,
            dischargeDateFrom,
            dischargeDateTo,
            dateFilterLogic,
            page + 1, // API expects 1-based page numbers
            rowsPerPage
          );
          // Handle the new response structure
          setAdmissions(response.data.list || response.data.data || []);
          setTotalRows(response.data.recordCount || response.data.count || 0);
        } else if (hasAdmissionDates) {
          // Only admission dates provided
          response = await AdmissionService.filterByAdmissionDate(
            admissionDateFrom,
            admissionDateTo,
            page,
            rowsPerPage
          );
          setAdmissions(response.data.list);
          setTotalRows(response.data.recordCount);
        } else if (hasDischargeDates) {
          // Only discharge dates provided
          response = await AdmissionService.filterByDischargeDate(
            dischargeDateFrom,
            dischargeDateTo,
            page,
            rowsPerPage
          );
          setAdmissions(response.data.list);
          setTotalRows(response.data.recordCount);
        }
      }

      setIsSearching(true);
    } catch (error) {
      console.error("Error filtering admissions:", error);
    }
  };

  const handleHospitalSearch = async () => {
    try {
      if (hospitalSearch.trim() !== "") {
        const response = await AdmissionService.getByHospital(
          hospitalSearch,
          page,
          rowsPerPage
        );
        setAdmissions(response.data.list);
        setTotalRows(response.data.recordCount);
        setIsSearching(true);
      }
    } catch (error) {
      console.error("Error filtering by hospital:", error);
    }
  };

  // Filter data based on search query

  const handleCountryChange = (e) => {
    setCountry(e.target.value);
  };

  const FormatDate = (date) => {
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [month, day, year].join("/");
  };

  const handleFacilitySave = (newFacility) => {
    fetchAndSetFacilities();
    setSelectedFacility(newFacility.id);
  };

  const handleInfoDialogClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setInfoDialogOpen(false);
  };

  const handleInfoSave = async (updatedAdmission) => {
    await AdmissionService.update(updatedAdmission.id, updatedAdmission);
    await AddAttachments(updatedAdmission.id, updatedAdmission.files);
    console.log("Updated Admission:", updatedAdmission);
    setInfoDialogOpen(false);
    await fetchAdmissions(page, rowsPerPage);
  };

  const handleDeleteAdmission = async (admissionId) => {
    try {
      //add confirmation
      const confirmed = window.confirm(
        "Are you sure you want to delete this admission?"
      );
      if (confirmed) {
        // Proceed with deletion
        //debugger;
        await AdmissionService.delete(admissionId);
        fetchAdmissions(page, rowsPerPage);
      } else {
        // User cancelled deletion
        console.log("Deletion cancelled by user");
      }
    } catch (error) {
      debugger;
      console.error("Error deleting admission:", error);
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    // Reset search states when switching tabs
    if (newValue !== 0) {
      setSearch("");
    }
    if (newValue !== 2) {
      setHospitalSearch("");
    }
    if (newValue !== 3) {
      setAdmissionDateFrom("");
      setAdmissionDateTo("");
      setDischargeDateFrom("");
      setDischargeDateTo("");
      setDateFilterLogic("AND");
      setEnableDischargeFilter(false);
    }
    if (newValue !== 1) {
      // Reset to empty string (no selection)
      setSelectedHospitalizationCountry("");
    }
    // Reset search results
    setIsSearching(false);
    setIsDateFiltering(false);
    setPage(0);
    // Fetch all admissions when switching tabs
    fetchAdmissions(0, rowsPerPage);
  };

  const handleDateFilter = async () => {
    try {
      const hasAdmissionDates = admissionDateFrom !== "" || admissionDateTo !== "";
      const hasDischargeDates = enableDischargeFilter && (dischargeDateFrom !== "" || dischargeDateTo !== "");
      
      if (hasAdmissionDates || hasDischargeDates) {
        setIsDateFiltering(true);
        let response;
        
        if (hasAdmissionDates && hasDischargeDates) {
          // Both admission and discharge dates provided - use combined filter
          response = await AdmissionService.filterByBothDates(
            admissionDateFrom,
            admissionDateTo,
            dischargeDateFrom,
            dischargeDateTo,
            dateFilterLogic,
            1, // API expects 1-based page numbers
            rowsPerPage
          );
          // Handle the new response structure
          setAdmissions(response.data.list || response.data.data || []);
          setTotalRows(response.data.recordCount || response.data.count || 0);
        } else if (hasAdmissionDates) {
          // Only admission dates provided
          response = await AdmissionService.filterByAdmissionDate(
            admissionDateFrom,
            admissionDateTo,
            0,
            rowsPerPage
          );
          setAdmissions(response.data.list);
          setTotalRows(response.data.recordCount);
        } else if (hasDischargeDates) {
          // Only discharge dates provided
          response = await AdmissionService.filterByDischargeDate(
            dischargeDateFrom,
            dischargeDateTo,
            0,
            rowsPerPage
          );
          setAdmissions(response.data.list);
          setTotalRows(response.data.recordCount);
        }
        
        setPage(0);
      }
    } catch (error) {
      console.error("Error filtering by date:", error);
    }
  };

  const handleExportToExcel = async () => {
    try {
      let response;
      if (selectedHospitalizationCountry !== "") {
        // Export by hospitalization country
        response = await AdmissionService.exportByHospitalizationCountry(
          selectedHospitalizationCountry
        );
      } else if (isSearching && search !== "") {
        // Export by text search
        response = await AdmissionService.exportByText(search);
      } else if (isSearching && hospitalSearch !== "") {
        // Export by hospital search
        response = await AdmissionService.exportByHospital(hospitalSearch);
      } else if (admissionDateFrom !== "" || admissionDateTo !== "" || 
                 (enableDischargeFilter && (dischargeDateFrom !== "" || dischargeDateTo !== ""))) {
        // Export by date range - check if both admission and discharge dates are provided
        const hasAdmissionDates = admissionDateFrom !== "" || admissionDateTo !== "";
        const hasDischargeDates = enableDischargeFilter && (dischargeDateFrom !== "" || dischargeDateTo !== "");
        
        if (hasAdmissionDates && hasDischargeDates) {
          // Both admission and discharge dates provided - use combined filter
          response = await AdmissionService.exportByBothDates(
            admissionDateFrom,
            admissionDateTo,
            dischargeDateFrom,
            dischargeDateTo,
            dateFilterLogic
          );
        } else if (hasAdmissionDates) {
          // Only admission dates provided
          response = await AdmissionService.exportByDate(
            admissionDateFrom,
            admissionDateTo
          );
        } else if (hasDischargeDates) {
          // Only discharge dates provided
          response = await AdmissionService.exportByDate(
            dischargeDateFrom,
            dischargeDateTo
          );
        }
      } else {
        // Export all (with discharged filter)
        response = await AdmissionService.exportAll(showDischarged ? 1 : 0);
      }

      // Get the data from the response
      const data = response.data.list;

      // Create Excel file with borders
      const excelData = createExcelData(data);
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(excelData);

      // Add borders and styling to all cells
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellAddress]) {
            worksheet[cellAddress] = { v: "" };
          }

          // Base styling for all cells
          const baseStyle = {
            border: {
              top: { style: "thin" },
              bottom: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
            },
          };

          // Add header styling for the first row (R === 0)
          if (R === 0) {
            worksheet[cellAddress].s = {
              ...baseStyle,
              font: { bold: true },
              fill: {
                fgColor: { rgb: "D3D3D3" }, // Light gray background
              },
            };
          } else {
            worksheet[cellAddress].s = baseStyle;
          }
        }
      }

      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Admissions");

      // Generate Excel file
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `admissions_export_${
        new Date().toISOString().split("T")[0]
      }.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      alert("Error exporting to Excel. Please try again.");
    }
  };

  const createExcelData = (data) => {
    if (!data || data.length === 0) {
      return [["No data available"]];
    }

    // Define the headers based on the columns
    const headers = [
      "Hospitalization Country",
      "Hospital",
      "Member Name",
      "Country",
      "Case #",
      "Date of Service TO",
      "Date of Service From",
      "Agency",
      "DOB",
      "Diagnosis Code",
    ];

    // Create Excel data array starting with headers
    const excelData = [headers];

    // Add data rows
    data.forEach((row) => {
      const rowData = [
        row.hospitalizationCountry || "Not specified",
        row.facilityName || "Not specified",
        `${row.lastName}, ${row.firstName}`,
        row.countryName || "Not specified",
        row.caseNumber || "",
        row.dischargeDate ? FormatDate(row.dischargeDate) : "",
        FormatDate(row.admissionDate),
        row.agency || "",
        FormatDate(row.dob),
        row.diagnosisCode || "Not specified",
      ];

      excelData.push(rowData);
    });

    return excelData;
  };

  return (
    <div className="ip-census-management-container" style={{ margin: "20px" }}>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <h2>Recent Admissions</h2>
      </div>
      {/* Search Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: "divider", marginBottom: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="search tabs"
        >
          <Tab label="Text Search" />
          <Tab label="Hospitalization Country Search" />
          <Tab label="Hospital Search" />
          <Tab label="Admission Date Search" />
        </Tabs>
      </Box>

      {/* Tab Content */}
      <Box role="tabpanel" hidden={activeTab !== 0} sx={{ marginBottom: 2 }}>
        {activeTab === 0 && (
          <Box display="flex" alignItems="center" gap={2}>
            <TextField
              label="Search"
              variant="outlined"
              size="small"
              value={search}
              disabled={showDischarged}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleSearch();
                }
              }}
              style={{ width: "200px" }}
            />
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#005f99",
                "&:hover": { backgroundColor: "#004d7a" },
              }}
              onClick={handleSearch}
              disabled={selectedHospitalizationCountry !== ""}
            >
              Search
            </Button>
            <Box display="flex" alignItems="center" gap={1}>
              <Switch
                checked={showDischarged}
                disabled={search.trim() !== ""}
                onChange={(e) => setShowDischarged(e.target.checked)}
                name="showDischarged"
                color="primary"
              />
              <label>Show Discharged Only</label>
            </Box>
          </Box>
        )}
      </Box>

      <Box role="tabpanel" hidden={activeTab !== 1} sx={{ marginBottom: 2 }}>
        {activeTab === 1 && (
          <Box display="flex" alignItems="center" gap={2}>
            <label style={{ minWidth: "150px" }}>
              Hospitalization Country:
            </label>
            <TextField
              select
              variant="outlined"
              size="small"
              value={selectedHospitalizationCountry}
              onChange={(e) => {
                setSelectedHospitalizationCountry(e.target.value);
                setPage(0);
                setShowDischarged(false);
              }}
              style={{ width: "200px" }}
              displayEmpty
            >
              <MenuItem value="" disabled>
                <em>Select a country</em>
              </MenuItem>
              {hospitalizationCountries
                .filter((country) => country !== "") // Filter out empty strings
                .map((country, index) => (
                  <MenuItem key={index} value={country}>
                    {country}
                  </MenuItem>
                ))}
            </TextField>
          </Box>
        )}
      </Box>

      <Box role="tabpanel" hidden={activeTab !== 2} sx={{ marginBottom: 2 }}>
        {activeTab === 2 && (
          <Box display="flex" alignItems="center" gap={2}>
            <TextField
              label="Hospital Search"
              variant="outlined"
              size="small"
              value={hospitalSearch}
              disabled={showDischarged}
              onChange={(e) => setHospitalSearch(e.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleHospitalSearch();
                }
              }}
              style={{ width: "200px" }}
            />
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#005f99",
                "&:hover": { backgroundColor: "#004d7a" },
              }}
              onClick={handleHospitalSearch}
              disabled={selectedHospitalizationCountry !== ""}
            >
              Search
            </Button>
          </Box>
        )}
      </Box>

      <Box role="tabpanel" hidden={activeTab !== 3} sx={{ marginBottom: 2 }}>
        {activeTab === 3 && (
          <Box>
            {/* Admission Date Filters */}
            <Box display="flex" alignItems="center" gap={2} marginBottom={2}>
              <Typography variant="subtitle2" sx={{ minWidth: "120px", fontWeight: "bold" }}>
                Admission Date:
              </Typography>
              <TextField
                label="From"
                variant="outlined"
                size="small"
                type="date"
                value={admissionDateFrom}
                onChange={(e) => setAdmissionDateFrom(e.target.value)}
                style={{ width: "150px" }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="To"
                variant="outlined"
                size="small"
                type="date"
                value={admissionDateTo}
                onChange={(e) => setAdmissionDateTo(e.target.value)}
                style={{ width: "150px" }}
                InputLabelProps={{ shrink: true }}
              />
            </Box>

            {/* Discharge Date Filters */}
            <Box display="flex" alignItems="center" gap={2} marginBottom={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={enableDischargeFilter}
                    onChange={(e) => {
                      setEnableDischargeFilter(e.target.checked);
                      if (!e.target.checked) {
                        // Clear discharge date fields when disabled
                        setDischargeDateFrom("");
                        setDischargeDateTo("");
                      }
                    }}
                    color="primary"
                  />
                }
                label={
                  <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                    Add Discharge Filter
                  </Typography>
                }
              />
            </Box>

            {enableDischargeFilter && (
              <>
                {/* Filter Logic Selector - Show above discharge date fields */}
                <Box display="flex" alignItems="center" gap={2} marginBottom={2} marginLeft={4}>
                  <Typography variant="subtitle2" sx={{ minWidth: "120px", fontWeight: "bold" }}>
                    Filter Logic:
                  </Typography>
                  <TextField
                    select
                    variant="outlined"
                    size="small"
                    value={dateFilterLogic}
                    onChange={(e) => setDateFilterLogic(e.target.value)}
                    style={{ width: "100px" }}
                  >
                    <MenuItem value="AND">AND</MenuItem>
                    <MenuItem value="OR">OR</MenuItem>
                  </TextField>
                  <Typography variant="body2" color="text.secondary">
                    (Both admission and discharge dates must match / Either admission or discharge date must match)
                  </Typography>
                </Box>

                {/* Discharge Date Fields */}
                <Box display="flex" alignItems="center" gap={2} marginBottom={2} marginLeft={4}>
                  <Typography variant="subtitle2" sx={{ minWidth: "120px", fontWeight: "bold" }}>
                    Discharge Date:
                  </Typography>
                  <TextField
                    label="From"
                    variant="outlined"
                    size="small"
                    type="date"
                    value={dischargeDateFrom}
                    onChange={(e) => setDischargeDateFrom(e.target.value)}
                    style={{ width: "150px" }}
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    label="To"
                    variant="outlined"
                    size="small"
                    type="date"
                    value={dischargeDateTo}
                    onChange={(e) => setDischargeDateTo(e.target.value)}
                    style={{ width: "150px" }}
                    InputLabelProps={{ shrink: true }}
                  />
                </Box>
              </>
            )}

            {/* Filter Button */}
            <Box display="flex" alignItems="center" gap={2}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#005f99",
                  "&:hover": { backgroundColor: "#004d7a" },
                }}
                onClick={handleDateFilter}
                disabled={
                  (admissionDateFrom === "" && admissionDateTo === "" && 
                   dischargeDateFrom === "" && dischargeDateTo === "")
                }
              >
                Filter by Date
              </Button>
            </Box>
          </Box>
        )}
      </Box>

      {/* Dividing Line */}
      <Divider sx={{ marginY: 2 }} />

      {/* Clear and Export Buttons */}
      <Box display="flex" justifyContent="space-between" marginBottom="15px">
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#005f99",
            "&:hover": { backgroundColor: "#004d7a" },
          }}
          onClick={() => {
            setSearch("");
            setHospitalSearch("");
            setAdmissionDateFrom("");
            setAdmissionDateTo("");
            setDischargeDateFrom("");
            setDischargeDateTo("");
            setDateFilterLogic("AND");
            setEnableDischargeFilter(false);
            // Reset to empty string (no selection)
            setSelectedHospitalizationCountry("");
            setIsSearching(false);
            setIsDateFiltering(false);
            fetchAll(0, rowsPerPage);
          }}
        >
          Clear
        </Button>
        <Button
          variant="contained"
          color="success"
          startIcon={<FileDownloadIcon />}
          onClick={handleExportToExcel}
        >
          Export to Excel
        </Button>
      </Box>
      <Dialog open={open} onClose={handleDialogClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          {editMode ? "Edit Admission" : "New Admission"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} style={{ marginTop: "5px" }}>
            {/*
              <Grid item xs={12} sm={4}>
                <TextField
                  required
                  label="Member ID"
                  className="mandatory-asterisk"
                  style={{ width: "89%" }}
                  value={memberId}
                  onChange={(e) => setMemberId(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  error={!!errors.memberId}
                  helperText={errors.memberId}
                />
                <IconButton onClick={handleMemberSearchOpen}>
                  <SearchIcon />
                </IconButton>
              </Grid> */}
            <Grid item xs={12} sm={4}>
              <TextField
                required
                label="First Name"
                inputProps={{ maxLength: 50 }}
                className="mandatory-asterisk"
                fullWidth
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                InputLabelProps={{ shrink: true }}
                error={!!errors.firstName}
                helperText={errors.firstName}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                label="Last Name"
                inputProps={{ maxLength: 50 }}
                className="mandatory-asterisk"
                fullWidth
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                InputLabelProps={{ shrink: true }}
                error={!!errors.lastName}
                helperText={errors.lastName}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                label="Date of Birth"
                className="mandatory-asterisk"
                fullWidth
                value={dob}
                type="date"
                onChange={(e) => setDob(e.target.value)}
                InputLabelProps={{ shrink: true }}
                error={!!errors.dob}
                helperText={errors.dob}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box display="flex" alignItems="center" width="100%">
                <Autocomplete
                  options={facilities}
                  getOptionLabel={(option) => option.name}
                  value={
                    facilities.find(
                      (facility) => facility.id === selectedFacility
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setSelectedFacility(newValue ? newValue.id : "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      label="Facility"
                      className="mandatory-asterisk"
                      style={{ width: "100%" }}
                      InputLabelProps={{ shrink: true }}
                      error={!!errors.selectedFacility}
                      helperText={errors.selectedFacility}
                    />
                  )}
                  style={{ width: "80%" }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddFacility}
                  style={{ marginLeft: "10px", height: "56px" }}
                >
                  <AddCircleIcon />
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Estimated Amount"
                className="mandatory-asterisk"
                fullWidth
                value={estimatedAmount}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only numbers and a single decimal point
                  if (/^\d*\.?\d*$/.test(value) || value === "") {
                    setEstimatedAmount(value);
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
                inputProps={{
                  inputMode: "decimal",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                label="Admit Date"
                className="mandatory-asterisk"
                fullWidth
                value={admissionDate}
                onChange={(e) => setAdmissionDate(e.target.value)}
                // onBlur={() => {
                //   if (admissionDate && !isPastDate(admissionDate)) {
                //     setErrors((prev) => ({
                //       ...prev,
                //       admissionDate: "Admit Date must be in the past.",
                //     }));
                //   } else {
                //     setErrors((prev) => ({ ...prev, admissionDate: null }));
                //   }
                // }}
                type="date"
                InputLabelProps={{ shrink: true }}
                error={!!errors.admissionDate}
                helperText={errors.admissionDate}
                // inputProps={{
                //   max: new Date().toISOString().split("T")[0], // Set max date to today
                // }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Discharge Date"
                fullWidth
                value={dischargeDate}
                onChange={(e) => setDischargeDate(e.target.value)}
                type="date"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                label="Country"
                className="mandatory-asterisk"
                fullWidth
                select
                value={country}
                onChange={handleCountryChange}
                InputLabelProps={{ shrink: true }}
                error={!!errors.country}
                helperText={errors.country}
              >
                {countries.map((country) => (
                  <MenuItem key={country.id} value={country.id}>
                    {country.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                label="Agency"
                className="mandatory-asterisk"
                inputProps={{ maxLength: 50 }}
                fullWidth
                value={agency}
                onChange={(e) => setAgency(e.target.value)}
                InputLabelProps={{ shrink: true }}
                error={!!errors.agency}
                helperText={errors.agency}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                label="Case Number"
                className="mandatory-asterisk"
                fullWidth
                value={caseNumber}
                onChange={(e) => setCaseNumber(e.target.value)}
                inputProps={{ maxLength: 50 }}
                InputLabelProps={{ shrink: true }}
                error={!!errors.caseNumber}
                helperText={errors.caseNumber}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Autocomplete
                options={diagnosisCodes}
                getOptionLabel={(option) =>
                  option.code + " - " + option.description
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Diagnosis Code"
                    className="mandatory-asterisk"
                    error={!!errors.diagnosisCode}
                    helperText={errors.diagnosisCode}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
                value={selectedDiagnosisCode}
                onChange={(event, newValue) =>
                  setSelectedDiagnosisCode(newValue)
                }
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Notes"
                fullWidth
                multiline
                rows={4}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <section className="container">
                <div {...getRootProps({ className: "dropzone" })}>
                  <input {...getInputProps()} />
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
                <aside className="thumbs-container">
                  {files.map((file, index) => (
                    <div
                      key={file.fileName ? file.fileName : file.name}
                      className="thumb"
                    >
                      <img
                        src={fileIcon}
                        alt="file icon"
                        className="thumb-icon"
                      />
                      <span className="thumb-text">
                        {file.fileName ? file.fileName : file.name}
                      </span>
                      <IconButton
                        onClick={async () =>
                          await handleDeleteFile(index, file.id)
                        }
                        aria-label="delete"
                        size="small"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </div>
                  ))}
                </aside>
              </section>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            {editMode ? "Update" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
      <FacilityForm
        open={facilityDialogOpen}
        onClose={handleFacilityDialogClose}
        onSave={handleFacilitySave}
      />
      <MemberSearchDialog
        open={memberSearchOpen}
        onClose={handleMemberSearchClose}
        onSelect={handleMemberSelect}
      />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column}>{column}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {admissions.length > 0 ? (
              admissions.map((row, index) => (
                <TableRow
                  key={index}
                  className={
                    DaysPassed(row.admissionDate) > 15 ? "red-row" : ""
                  }
                >
                  <TableCell style={{ fontSize: "3px !important" }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <span>
                        {row.hospitalizationCountry ?? "Not specified"}
                      </span>
                      <IconButton
                        size="small"
                        onClick={() => {
                          handleAddressDialogOpen({
                            facilityName: row.facilityName,
                            hospitalizationCountry: row.hospitalizationCountry,
                            hospitalizationCity: row.hospitalizationCity,
                            hospitalizationPostalCode:
                              row.hospitalizationPostalCode,
                            hospitalizationState: row.hospitalizationState,
                          });
                        }}
                        sx={{
                          padding: "2px",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                      >
                        <LocationOnIcon
                          sx={{
                            fontSize: "16px",
                            color: hasAddressData(row) ? "#4caf50" : "#666",
                          }}
                        />
                      </IconButton>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Tooltip title={row.facilityName} arrow>
                      <span>
                        {row.facilityName && row.facilityName.length > 30
                          ? `${row.facilityName.substring(0, 30)}...`
                          : row.facilityName ?? "Not specified"}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell>{row.lastName + ", " + row.firstName}</TableCell>
                  <TableCell style={{ fontSize: "3px !important" }}>
                    {row.countryName ?? "Not specified"}
                  </TableCell>
                  <TableCell>{row.caseNumber}</TableCell>
                  <TableCell>
                    {row.dischargeDate ? FormatDate(row.dischargeDate) : ""}
                  </TableCell>
                  <TableCell>{FormatDate(row.admissionDate)}</TableCell>
                  <TableCell>
                    <Tooltip title={row.agency} arrow>
                      <span>
                        {row.agency.length > 30
                          ? `${row.agency.substring(0, 30)}...`
                          : row.agency}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell>{FormatDate(row.dob)}</TableCell>
                  <TableCell>
                    <Tooltip title={row.diagnosisCode} arrow>
                      <span>
                        {row.diagnosisCode.length > 30
                          ? `${row.diagnosisCode.substring(0, 30)}...`
                          : row.diagnosisCode || row.diagnosisCode === ""
                          ? "Not specified"
                          : row.diagnosisCode}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <IconButton
                      className="detail-icon-button"
                      onClick={async () => await handleInfoDialogOpen(row)}
                    >
                      <DescriptionIcon />
                    </IconButton>
                    <IconButton
                      className="detail-icon-button"
                      onClick={async () => await handleDeleteAdmission(row.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  No data available in table
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
      {isProfileOpen && (
        <Profile
          memberId={selectedMemberId}
          isOpen={isProfileOpen}
          onClose={handleProfileClose}
        />
      )}
      {selectedAdmission && (
        <AdmissionInfoDialog
          open={infoDialogOpen}
          onClose={handleInfoDialogClose}
          admission={selectedAdmission}
          onSave={handleInfoSave}
        />
      )}

      {/* Address Dialog */}
      <Dialog
        open={addressDialogOpen}
        onClose={handleAddressDialogClose}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown
      >
        <DialogTitle alignContent={"center"}>
          Hospitalization Details
        </DialogTitle>
        <DialogContent>
          {selectedHospitalAddress && (
            <Box sx={{ mt: 2 }}>
              <Box sx={{ mb: 2 }}>
                <strong>Hospital Name:</strong>
                <Box
                  sx={{
                    mt: 1,
                    p: 2,
                    backgroundColor: "#f5f5f5",
                    borderRadius: 1,
                  }}
                >
                  {selectedHospitalAddress.facilityName || "Not specified"}
                </Box>
              </Box>

              <Box sx={{ mb: 2 }}>
                <strong>City:</strong>
                <Box
                  sx={{
                    mt: 1,
                    p: 2,
                    backgroundColor: "#f5f5f5",
                    borderRadius: 1,
                  }}
                >
                  {selectedHospitalAddress.hospitalizationCity ||
                    "Not specified"}
                </Box>
              </Box>

              <Box sx={{ mb: 2 }}>
                <strong>State:</strong>
                <Box
                  sx={{
                    mt: 1,
                    p: 2,
                    backgroundColor: "#f5f5f5",
                    borderRadius: 1,
                  }}
                >
                  {selectedHospitalAddress.hospitalizationState ||
                    "Not specified"}
                </Box>
              </Box>

              <Box sx={{ mb: 2 }}>
                <strong>Country:</strong>
                <Box
                  sx={{
                    mt: 1,
                    p: 2,
                    backgroundColor: "#f5f5f5",
                    borderRadius: 1,
                  }}
                >
                  {selectedHospitalAddress.hospitalizationCountry ||
                    "Not specified"}
                </Box>
              </Box>

              {selectedHospitalAddress.hospitalizationPostalCode && (
                <Box sx={{ mb: 2 }}>
                  <strong>Postal Code:</strong>
                  <Box
                    sx={{
                      mt: 1,
                      p: 2,
                      backgroundColor: "#f5f5f5",
                      borderRadius: 1,
                    }}
                  >
                    {selectedHospitalAddress.hospitalizationPostalCode}
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleAddressDialogClose}
            variant="contained"
            sx={{
              backgroundColor: "#005f99",
              "&:hover": { backgroundColor: "#004d7a" },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default IPCensusManagement;
